import { useMemo } from 'react';
import { Badge, Tag, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import type { PlanScheduleRow } from '../types';
import { formatAssetLabel, formatDate } from '../utils';

const { Text } = Typography;

export function usePlanDetailScheduleColumns(): ColumnsType<PlanScheduleRow> {
  const { t } = useTranslation('maintenance');

  return useMemo(
    () => [
      {
        title: t('detail.schedules.asset'),
        key: 'asset',
        render: (_: unknown, row: PlanScheduleRow) => (
          <Text>{formatAssetLabel(row.assetName, row.serialNumber)}</Text>
        ),
      },
      {
        title: t('detail.schedules.trigger'),
        dataIndex: 'triggerLabel',
        key: 'triggerLabel',
        render: (label: string) => <Tag color="blue">{label}</Tag>,
      },
      {
        title: t('plans.active'),
        dataIndex: 'active',
        key: 'active',
        width: 120,
        render: (val: boolean) =>
          val ? (
            <Badge status="success" text={t('common.active')} />
          ) : (
            <Badge status="default" text={t('common.inactive')} />
          ),
      },
      {
        title: t('detail.schedules.nextDueAt'),
        dataIndex: 'nextDueAt',
        key: 'nextDueAt',
        render: (val: string | null) => formatDate(val),
      },
      {
        title: t('detail.schedules.nextDueReading'),
        dataIndex: 'nextDueReading',
        key: 'nextDueReading',
        render: (val: number | null) => (val == null ? '—' : String(val)),
      },
    ],
    [t],
  );
}
